module.exports = __webpack_public_path__ + "img/ksh_pho1.ac024029.png";